// extracted by mini-css-extract-plugin
export default {"personalizationWrapper":"input-personalization_personalizationWrapper__aTx2e","emoji":"input-personalization_emoji__Ym+C2"};